<core-label *ngFor="let label of labels" [label]="label"></core-label>
